import {
  FormControl,
  FormControlLabel,
  FormGroup,
  Switch,
} from "@mui/material";
import { useEffect } from "react";

interface CustomCheckboxProps extends React.ReactElement {
  fieldKey: string;
  value: boolean;
  onChange: (key: string, value: boolean) => void;
  label: string;
  disabled: boolean;
  required: boolean;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  fieldKey,
  value = false,
  onChange,
  label,
  disabled,
  required,
}) => {
  useEffect(() => {
    // to set the default value to form
    onChange(fieldKey, value);
  }, [onChange, value, fieldKey]);

  const handleChange = (e: any) => {
    onChange(fieldKey, e.target.checked);
  };

  return (
    <FormControl
      component="fieldset"
      variant="standard"
      required={required}
      disabled={disabled}
    >
      <FormGroup>
        <FormControlLabel
          key={fieldKey}
          control={
            <Switch checked={!!value} onChange={handleChange} name={label} />
          }
          label={label}
        />
      </FormGroup>
    </FormControl>
  );
};

export default CustomCheckbox;
